import React from "react";
import Scaffold from "../commons/scaffold/scaffold";
import { VMProvider } from "../commons/base/providers/provider";
import FinishCookingDashboardViewModel from "./view_models/finish_cooking_dashboard_view_model";
import FinishCookingOrderCellWidget from "./widgets/finish_cooking_order_cell_widget";

export default class FinishCookingDashboardScreen extends React.Component {
    render(): React.ReactNode {
        return (
            <VMProvider create={() => new FinishCookingDashboardViewModel()}>
                {(vm) => (
                    <Scaffold
                        isShowLoading={vm.isSubmitting}
                        loadingType="three_dots"
                        loadingBackgroundType="semi_transparent"
                        showSnackbar={vm.snackBar}
                    >
                        <div className=" bg-slate-500 overflow-x-auto min-h-screen p-5 mt-10 relative">
                            <h1 className="text-white text-3xl text-center font-bold flex-grow m-5">
                                Finish Cooking Dashboard
                            </h1>
                            <div className="m-5 p-5 items-start grid grid-cols-3 md:grid-cols-6">
                                {[...vm.ordersMap.values()].map((model) => (
                                    <FinishCookingOrderCellWidget
                                        key={model.id}
                                        model={model}
                                        onTick={(args) => vm.tickOrder(args)}
                                    />
                                ))}
                            </div>
                        </div>
                    </Scaffold>
                )}
            </VMProvider>
        );
    }
}
